import { jsx } from 'react/jsx-runtime';
import '../../../../contexts/MenuContext/index.mjs';
import { CustomButton, LanguageValue } from '../LanguageFrame.styles.mjs';
import { ENGLISH_LANGUAGES_SORTED } from '../translations/index.mjs';
import { buildLanguageLink } from '../utils/buildLanguageLink.mjs';
import { getLanguageLabel } from '../utils/getLanguageLabel.mjs';
import { Wrap } from './Mobile.styles.mjs';
import { useMenu } from '../../../../contexts/MenuContext/context.mjs';
"use strict";
const LanguageFrameMobile = ({
  onLanguageChange,
  onClose
}) => {
  const {
    deployedLanguages,
    language,
    storeId,
    setActiveModal
  } = useMenu();
  return /* @__PURE__ */jsx(Wrap, {
    children: Object.keys(ENGLISH_LANGUAGES_SORTED).map(key => {
      if (deployedLanguages.includes(key)) {
        const href = buildLanguageLink(storeId, key);
        if (!href) return null;
        return /* @__PURE__ */jsx(CustomButton, {
          anchor: true,
          $active: key === language,
          variant: "gray",
          href,
          onClick: e => {
            onLanguageChange?.(e, href, key);
            setActiveModal(null);
            onClose?.();
          },
          children: /* @__PURE__ */jsx(LanguageValue, {
            children: getLanguageLabel(key)
          })
        }, key);
      } else {
        return null;
      }
    })
  });
};
export { LanguageFrameMobile };
//# sourceMappingURL=Mobile.mjs.map
